module.exports = __webpack_public_path__ + "img/hermelin_loader.3cf3da56.svg";